// @flow

import { createSelector } from 'reselect';

import type { UserReducer, User } from '../../common/types/userTypes';

import { INIT_STATE } from '../../common/reducers/UserReducer';

export function getState(state: any): UserReducer {
  return (state && state.user) || INIT_STATE;
}

export const getUserData: (state: any) => ?User = createSelector(
  getState,
  userState => (userState && userState.data) || undefined
);

export const getLimitedUserData: (state: any) => any = createSelector(
  getUserData,
  userData => {
    if (!userData) {
      return undefined;
    }
    const { name, last_name, email } = userData;
    return { name, last_name, email };
  }
);

export const isAgencyUser: (state: any) => boolean = createSelector(
  getState,
  state => {
    return Boolean(state.data && state.data.agency_user == 1);
  }
);

export const isLoading: (state: any) => boolean = createSelector(
  getState,
  state => {
    return Boolean(state.isLoading && state.isLoading == 1);
  }
);

export const getUserAccessRoleId: (state: any) => string = createSelector(
  getState,
  state => {
    return state && state.access_role_id;
  }
);
